import styles from "components/layout/brands/BrandNameCategoryIndex.module.scss";
import {forwardRef, useEffect, useRef} from "react";
import {useDraggable} from "react-use-draggable-scroll";
import classNames from "classnames";
import {getPixelValueFromString} from "common/utils";
import utilStyles from "styles/utils.module.scss";

const CATEGORY_KEY_NEW = 'NEW';


const BrandCategoryButton = forwardRef((props, ref) => {
    const {text, selected, onClick, isNew} = props;
    return (
        <div className={classNames(styles.categoryButtonWrapper)} onClick={onClick} ref={ref}>
            <div className={classNames(
                styles.categoryButton,
                selected ? styles.selectedButton : undefined,
                isNew && selected ? styles.selectedNewButton: undefined,
            )} style={{fontWeight: isNew ? '700' : undefined}}>
                {text}
            </div>
        </div>
    );
});


export const BrandNameCategoryIndex = (props) => {
    const {currentCategoryKey, setCurrentCategoryKey} = props;

    const categorySelectorRef = useRef(null);
    const categoryList = ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', '#'];

    const { events } = useDraggable(categorySelectorRef);

    const buttonRefs = useRef({});

    useEffect(() => {
        if (currentCategoryKey && Object.keys(buttonRefs.current).length > 0 && categorySelectorRef.current) {
            const button = buttonRefs.current[currentCategoryKey];
            categorySelectorRef.current.scrollTo(button.offsetLeft - getPixelValueFromString(utilStyles.layoutLeftPaddingNew), 0);
        }
    }, []);

    const onCategoryClick = (category) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BrandListPageCategoryClick', {category});
        setCurrentCategoryKey(category);
    };

    return (
        <div ref={categorySelectorRef} className={styles.categorySection}
             {...events}>
            {
                categoryList.map(x =>
                    <BrandCategoryButton
                        ref={(_ref) => buttonRefs.current[x] = _ref}
                        key={`category_${x}`} text={x} selected={currentCategoryKey === x}
                        onClick={() => onCategoryClick(x)}
                        isNew={x === CATEGORY_KEY_NEW}
                    />
                )
            }
        </div>
    )
};
